import { Popper, styled, tooltipClasses } from "@mui/material";

import { FontWeights } from "config";

import { ICustomizedTooltipPopperProps } from "./types";

export const CustomizedTooltipPopper = styled(Popper, {
  shouldForwardProp: (prop) => prop !== "tooltipAdditionalStyles",
})<ICustomizedTooltipPopperProps>(({ theme, tooltipAdditionalStyles }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.custom.dark_blue,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: FontWeights._400,
    padding: "7px 9px 6px",
    borderRadius: theme.shape.borderRadius[0],
    ...theme.unstable_sx(tooltipAdditionalStyles || {}),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.custom.dark_blue,
  },
}));
